// extracted by mini-css-extract-plugin
export default {"main_button":"MainButton_main_button__e4a2Z","disabled":"MainButton_disabled__jjFB1"};